export default __webpack_public_path__ + "static/media/wakanda5.6ed7f0bd.jpg";